export const MALL_RECEPTION = 'mall_reception';
